



















import Vue from 'vue'

import * as routerNames from '@/services/router/router.names'

export default Vue.extend({
  name: 'DdMobileMenu',

  computed: {
    navItems(): Array<any> {
      return this.$permissions.isNotGuest
        ? [
            {
              label: 'Home',
              icon: 'home',
              pathName: routerNames.DASHBOARD,
            },
            {
              label: 'Tasks',
              icon: 'task',
              pathName: routerNames.ALL_TASKS,
            },
            {
              label: 'Conversations',
              icon: 'conversation',
              pathName: routerNames.ALL_CONVERSATIONS,
            },
            {
              label: 'Calendar',
              icon: 'calendar',
              pathName: routerNames.CALENDAR,
            },
          ]
        : [
            {
              label: 'Home',
              icon: 'home',
              pathName: routerNames.DASHBOARD,
            },
            {
              label: 'Tasks',
              icon: 'task',
              pathName: routerNames.ALL_TASKS,
            },
            {
              label: 'Calendar',
              icon: 'calendar',
              pathName: routerNames.CALENDAR,
            },
          ]
    },
  },
})
